<h2>Documentos Cliente</h2>
<tree-root #docs [focused]="true" [nodes]="nodes" [options]="this.options"></tree-root>